import { __assign, __rest } from "tslib";
import React from 'react';
var CardContent = function (props) {
    var prefixCls = props.prefixCls, children = props.children, otherProps = __rest(props, ["prefixCls", "children"]);
    return (React.createElement("div", __assign({}, otherProps, { className: prefixCls + "__body" }), children));
};
CardContent.displayName = 'CardContent';
export default CardContent;
//# sourceMappingURL=card-content.js.map